import type { Metric } from 'web-vitals';
import { routeTemplate } from '@/routes/routeTemplate';
import { sendVital, VitalPayload } from '@/services/telemetryService';

type VitalName = Metric['name'] | 'first_chart';

const THRESHOLDS: Record<VitalName, readonly [number, number]> = {
  CLS: [0.1, 0.25],
  FCP: [1800, 3000],
  FID: [100, 300],
  LCP: [2500, 4000],
  TTFB: [800, 1800],
  first_chart: [2500, 4000],
};

const rate = (name: VitalName, value: number): VitalPayload['rating'] => {
  const [good, poor] = THRESHOLDS[name];
  if (value <= good) return 'good';
  return value <= poor ? 'needs-improvement' : 'poor';
};

const loadNavigationType = (): string => {
  const [entry] = performance.getEntriesByType?.('navigation') ?? [];
  return (entry as PerformanceNavigationTiming | undefined)?.type ?? 'navigate';
};

export const reportVital = (name: VitalName, value: number, navType = loadNavigationType()) =>
  sendVital({
    name,
    value,
    route: routeTemplate(window.location.pathname),
    rating: rate(name, value),
    nav_type: navType,
  });

const reportWebVitals = (): void => {
  if (process.env.NODE_ENV !== 'production') return;
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    const handler = (metric: Metric) => reportVital(metric.name, metric.value);
    [getCLS, getFID, getFCP, getLCP, getTTFB].forEach(subscribe => subscribe(handler));
  });
};

export default reportWebVitals;
